import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "pre" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("pre", _hoisted_1, [
    _createElementVNode("code", {
      class: "chat-text language-markdown",
      innerHTML: _ctx.msgFormatted
    }, null, 8, _hoisted_2)
  ], 512))
}